// Ground rent: blank = unknown (null), 0 = "Peppercorn", positive amounts keep their own formatting.
export const isZeroGroundRent = (raw) => {
  if (raw === null || raw === undefined) return false;
  const s = String(raw).trim();
  return s !== "" && !s.includes("-") && /\d/.test(s) && Number(s.replace(/[^0-9.]/g, "")) === 0;
};

export const groundRentLabel = (raw, formatPositive) => {
  if (raw === null || raw === undefined || String(raw).trim() === "") return null;
  return isZeroGroundRent(raw) ? "Peppercorn" : formatPositive(raw);
};
